module.exports = __webpack_public_path__ + "assets/img/Type E (19).8851d2ec.jpg";